import { render, staticRenderFns } from "./UNClass.vue?vue&type=template&id=c95ee1f2"
import script from "./UNClass.vue?vue&type=script&lang=js"
export * from "./UNClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports